import React, { useCallback, useContext, useState } from "react";
import api from "services/interceptor";
import { levels as defaultLevels } from "utils/levels";

const QuizContext = React.createContext({
  activeCompetition: null,
  activeQuiz: null,
  activeQuizLevel: null,
  players: null,
  getAccessToken: () => "",
  updatePlayers: () => {},
  updateActiveQuiz: () => {},
  updateActiveQuizLevel: () => {},
  updateActiveCompetiton: () => {}
});

export const QuizProvider = ({ children }) => {
  const [user, setUser] = useState();
  const [activeCompetition, setActiveCompetition] = useState(null);
  const [activeQuiz, setActiveQuiz] = useState(null);
  const [activeQuizLevel, setActiveQuizLevel] = useState(defaultLevels[0]);
  const [players, setPlayers] = useState(null);

  const updateActiveCompetiton = useCallback((competition) => {
    setActiveCompetition(competition);
  }, []);

  const updatePlayers = useCallback((players) => {
    setPlayers(players);
  }, []);

  const updateActiveQuiz = useCallback((quiz) => {
    setActiveQuiz(quiz);
  }, []);

  const updateActiveQuizLevel = useCallback((level) => {
    setActiveQuizLevel(level);
  }, []);

  const getUser = useCallback(async () => {
    try {
      const url = "/auth/profile";
      const response = await api.get(url);

      if (response?.data?.data) {
        setUser(response?.data?.data);
      }
    } catch (e) {
      console.log(e);
    }
  }, []);

  return (
    <QuizContext.Provider
      value={{
        user,
        activeCompetition,
        activeQuiz,
        players,
        activeQuizLevel,
        getUser,
        updatePlayers,
        updateActiveQuiz,
        updateActiveQuizLevel,
        updateActiveCompetiton
      }}
    >
      {children}
    </QuizContext.Provider>
  );
};

export function useQuiz() {
  const quizContext = useContext(QuizContext);

  return quizContext;
}
